import { styled } from '@mui/system'

export const Logo = styled('img', { shouldForwardProp: prop => prop !== 'reduced' })<{
  reduced: boolean
}>`
  height: ${({ reduced }) => (reduced ? '34px' : '30px')};
  width: auto;
  display: block;

  @media (min-width: 1920px) {
    height: ${({ reduced }) => (reduced ? '38px' : '34px')};
  }
`
